module.exports = __webpack_public_path__ + "static/img/1_3.fafda273.jpg";